import React, { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { dbForm, dbPost } from '../../apis/commonApi';
import TextEditor from '../../components/inputComponents/TextEditor';
import FileUpload from '../../components/modalComponents/FileUpload';
import { GlobalContext } from '../../components/contexts';
import { nlPost } from '../../apis/notLoginApi';

const RegQuestion = () => {
  useEffect(() => {
    document.title = '문의 등록';
  }, []);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [title, setTitle] = useState('');
  const editorRef = useRef(null);
  const [isFileModalOpen, setIsFileModalOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [sharedFileId, setSharedFileId] = useState(null);
  const [currentFileSeq, setCurrentFileSeq] = useState(null);
  const { store } = useContext(GlobalContext);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const url = '/cs/category/list.do';
        const response = await nlPost(url, {});
        if (response.length > 0) {
          const filteredCategories = response.filter(cat => cat.useYn === 'Y');
          setCategories(filteredCategories);
        }
      } catch (error) {}
    }; 

    fetchCategories();
  }, []);

  const handleFileUpload = uploadedFilePath => {
    const cleanPath = uploadedFilePath.replace(/^.*[\\/]/, '');
    const uploadedUrl = `${process.env.REACT_APP_BACKEND_URL}/files/${cleanPath}`;
    if (editorRef.current) {
      const editorInstance = editorRef.current.getInstance();
      const currentCn = editorInstance.getMarkdown();
      const imageMarkdown = `![이미지 설명](${uploadedUrl})`;
      editorInstance.setMarkdown(`${currentCn}\n${imageMarkdown}`);
    }
  };

  const handleSubmit = async () => {
    if (!selectedCategory) {
      alert('카테고리를 선택해주세요.');
      return;
    }
    if (!title.trim()) {
      alert('제목을 입력해주세요.');
      return;
    }
    if (title.length > 33) {
      alert('제목은 33글자를 초과할 수 없습니다.');
      return;
    }
    const cn = editorRef.current.getInstance().getMarkdown();
    if (!cn.trim()) {
      alert('내용을 입력해주세요.');
      return;
    }
    if (cn.length > 1000) {
      alert('내용은 1000글자를 초과할 수 없습니다.');
      return;
    }

    const payload = {
      ctgryId: selectedCategory,
      qstnTtl: title,
      qstnCn: cn,
      fileId: sharedFileId,
    };

    if (store?.userType === 'U') {
      payload.userSn = store?.userSn || '';
      payload.entSn = store?.entSn || '';
    } else {
      payload.entSn = store?.entSn || '';
      payload.userSn = null;
    }

    try {
      const url = '/cs/ask/create.do';
      await dbPost(url, payload);
      alert('문의가 성공적으로 등록되었습니다.');
      navigate('/cs/question/questionList');
    } catch (error) {
      alert('문의 등록 중 문제가 발생했습니다.');
    }
  };

  const goToList = () => {
    navigate('/cs/question/questionList');
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">문의하기</h2>
      </div>
      <ul className="guide-txt">
        <li>
          시스템 이용과 관련한 문의사항, 불편사항 등을 작성해주세요. 빠른 시간
          내에 답변 드리도록 하겠습니다.
        </li>
      </ul>
      <div className="tbl-wrap">
        <p className="tbl-msg">
          <em className="star-require">*</em> 표시는 필수 입력 사항입니다.
        </p>
        <table className="tbl data row">
          <caption>문의사항 등록을 위한 테이블입니다.</caption>
          <tbody>
            <tr>
              <th scope="row">
                카테고리<em className="star-require">*</em>
              </th>
              <td>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="sel1">
                    라벨
                  </label>
                  <select
                    id="sel1"
                    className="form-select md"
                    value={selectedCategory}
                    onChange={e => setSelectedCategory(e.target.value)}
                  >
                    <option value="">카테고리</option>
                    {categories
                      .filter(cat => cat.ctgryId !== 'NOTICE')
                      .map(cat => (
                        <option key={cat.ctgryId} value={cat.ctgryId}>
                          {cat.ctgryNm}
                        </option>
                      ))}
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                제목<em className="star-require">*</em>
              </th>
              <td>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="title">
                    라벨
                  </label>
                  <input
                    type="text"
                    className="form-control md"
                    placeholder="제목 입력"
                    value={title}
                    onChange={e => setTitle(e.target.value)}
                    aria-labelledby="title"
                    id="title"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                내용<em className="star-require">*</em>
              </th>
              <td>
                <TextEditor
                  ref={editorRef}
                  initialValue=""
                  placeholder="내용을 입력해주세요."
                  id="cn"
                  aria-labelledby="cn"
                />
              </td>
            </tr>
            <tr>
              <th scope="row">첨부파일</th>
              <td>
                <div className="input-group">
                  <button
                    type="button"
                    className="btn tertiary"
                    onClick={() => setIsFileModalOpen(true)}
                  >
                    파일 첨부
                  </button>
                </div>
                {uploadedFiles.length > 0 && (
                  <p>첨부된 파일 개수: {uploadedFiles.length}개</p>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="page-btn-wrap both">
        <button type="button" className="btn xlg tertiary" onClick={goToList}>
          돌아가기
        </button>
        <button
          type="button"
          className="btn xlg primary"
          onClick={handleSubmit}
        >
          문의하기
        </button>
      </div>
      {isFileModalOpen && (
        <FileUpload
          onClose={() => setIsFileModalOpen(false)}
          dbPost={dbPost}
          dbForm={dbForm}
          selectedFiles={selectedFiles}
          setSelectedFiles={setSelectedFiles}
          uploadedFiles={uploadedFiles}
          setUploadedFiles={setUploadedFiles}
          sharedFileId={sharedFileId}
          setSharedFileId={setSharedFileId}
          currentFileSeq={currentFileSeq}
          setCurrentFileSeq={setCurrentFileSeq}
          onUpload={handleFileUpload}
        />
      )}
    </>
  );
};

export default RegQuestion;
